import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Store Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-store-outline',
    templateUrl: './icon-store-outline.component.html',
    styleUrls: ['./icon-store-outline.component.scss'],
    standalone: false
})
export class IconStoreOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
